import Screening from '@/fstore/collections/Screening'
import Job from '@/fstore/collections/Job'
import Company from '@/fstore/collections/Company'

/**
 * FetchAll takes an object with one of the following properties
 * - UserId: returns all screenings for a candidate.
 * - CompanyId: returns all screenings for a company across all jobs.
 * - JobId:  returns all screenings for a job. This includes ones responded to, declined, expired, etc...
 * 
 * If more than one property is provided, the priority goes:
 * - UserId
 * - CompanyId
 * - JobId
 */
const fetchAll = async ({commit, dispatch}, {userId, companyId, jobId}) => {
    dispatch('app/setOverlay', true, { root: true });

    const screenings = [];
    // verify we have data. if none of the properties exist, just exit the routine
    if(!userId && !companyId && !jobId){
        // should probably tell people not to be dumb here...
        console.error("Please call Screening.fetchAll with an object containing either userId, companyId, or jobId");
        return screenings;
    }

    // something valid is in here, let's check it out
    if(userId)
        screenings.push(...(await _fetchAllByUserId(userId)));
    if(companyId)
        screenings.push(...(await _fetchAllByCompanyId(companyId)));
    if(jobId)
        screenings.push(...(await _fetchAllByJobId(jobId)));

    // get the job data for all screenings
    const getJobDataForScreenings = async (screening) => {
        const job = await Job.getById(screening.jobRef.id);
        return job;
    }

    for(let screening of screenings) {
        screening.job = await getJobDataForScreenings(screening);
    }

    // get counts
    const numAvailableAnswers = screenings.filter(screening => !screening.connectionRequest.sent && screening.status.submitted).length;
    const numAwaitingResponse = screenings.filter(screening => !screening.connectionRequest.sent).length - numAvailableAnswers;

    commit('setData', {screenings, numAvailableAnswers, numAwaitingResponse});
    
    dispatch('app/setOverlay', false, { root: true });
}

// private helpers for fetch all

const _fetchAllByUserId = async (userId) => {
    const screenings = await Screening.fetchScreeningsForUser(userId);

    for(const screening of screenings){
        screening.company = await Company.getByRef(screening.companyRef);
        // screening.company = await (screening.companyRef.get()).data()
    }

    return screenings;
}

const _fetchAllByCompanyId = async companyId => {
    const screenings = await Screening.fetchScreeningsForCompany(companyId);
    return screenings;
}

const _fetchAllByJobId = async jobId => {
    const screenings = await Screening.fetchScreeningsForJob(jobId)
    return screenings;
}

const update = async ({state}) => {
    dispatch('app/setOverlay', true, { root: true });
    await Screening.update(state);

    dispatch('app/setOverlay', false, { root: true });
}

const reset = ({ commit }) => {
    commit('setData', {});
  }

export default {
    fetchAll,
    reset,
}